const accessori = {
    state: {
        component: 'Index',
        edit: false,
        all: []
    },
    mutations: {
        CHANGE_ACCESSORI_COMPONENT(state, payload) {
            state.component = payload
        },
        CHANGE_ACCESSORI_EDIT(state, payload) {
            state.edit = payload
        }
    },
    getters: {
        getAccessoriComponent: state => state.component,
        getAccessoriEdit: state => state.edit
    }
}

export default accessori